import { InfiniteData, UseInfiniteQueryResult } from "@tanstack/react-query";

import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";

import MovieCard from "@/components/cards/MovieCard";
import Carousel from "@/components/helpers/Carousel";
import Section from "@/components/helpers/Section/Section";
import SectionSkeleton from "@/components/helpers/Section/Section.skeleton";

import type { Content, Pagination } from "@/@types/general";
import { ROUTES } from "@/config/routes";
import { isMobile } from "@/utils/constatns";

const SearchContentSection = ({
  content,
}: {
  content: UseInfiniteQueryResult<InfiniteData<Pagination<Content>, unknown>, Error>;
}) => {
  const { data: contentData, isPending } = content;

  const { t } = useTranslation();

  const [params] = useSearchParams();

  if (isPending) {
    return (
      <SectionSkeleton
        type={"content"}
        title={t("Actions.movie-and-series")}
        link={`${ROUTES.SEARCH_CONTENT}?${params}`}
      />
    );
  }

  if (!contentData || contentData.pages[0].results.length == 0) return <></>;

  return (
    <Section
      title={t("Actions.movie-and-series")}
      link={`${ROUTES.SEARCH_CONTENT}?${params}`}
      className={`group/section`}
    >
      <Carousel<Content>
        swiperParams={{
          slidesPerView: 2,
          spaceBetween: 16,
          followFinger: isMobile,
          breakpoints: {
            576: { slidesPerView: 3, slidesPerGroup: 3 },
            992: { slidesPerView: 4, slidesPerGroup: 4 },
            1200: { slidesPerView: 5, slidesPerGroup: 5, spaceBetween: 12 },
            1400: { slidesPerView: 6, slidesPerGroup: 6, spaceBetween: 16 },
          },
        }}
        items={contentData.pages[0].results}
        swiperName={"search-result"}
      >
        {(content) => <MovieCard key={content.id} {...content} />}
      </Carousel>
    </Section>
  );
};

export default SearchContentSection;
